module.exports = __webpack_public_path__ + "static/media/img_homepage_content_Resourcefoyou-04_Parents.0d188da2.png";